<template>
    <div class="collabsable-section" v-if="forgesettings">
        <div class="section-title clickable-header" @click="toggleExpanded()">
            <div class="fas fa-map" style="font-size: 18px;margin-right: 10px;"></div>
            <div style="flex-grow: 1;font-size: 17px;">GPS Settings</div>
            <div style="color: gray;" :class="['expand-collapse-ico', 'fas', !isExpanded ? 'fa-caret-down' : 'fa-caret-up']">
            </div>
        </div>
        <div v-if="isExpanded" class="expanded-section">
            <div class="row-input">
                <div style="width: 30%;">System Type:</div>
                <select style="flex-grow: 1;" v-model="selectedgpssystem" placeholder="Select System"
                    @change="onGPSSystemChanged($event)">
                    <option v-for="item in gpsSystems" :key="item">{{ item }}</option>
                </select>
            </div>
            <p style="padding-left: 8px;color: red;padding-top: 10px;">Please input the coordinates of the same point in
                both Site and 3D model</p>
            <div class="row-input">
                <div style="width: 30%;">UTM Site Point (N,E):</div>
                <input type="number" v-virtual-keyboard name="gpsOriginN" v-model="forgesettings.gpsSettings.originN"
                    style="width: 30%;flex-grow: 1;margin-right: 10px;" placeholder="Site Point North (N)" />
                <input type="number" v-virtual-keyboard name="gpsOriginN" v-model="forgesettings.gpsSettings.originE"
                    style="width: 30%;flex-grow: 1;margin-right: 10px;" placeholder="Site Point East (E)" />
            </div>
            <div class="row-input">
                <div style="width: 30%;">Model 3D Point (X,Y):</div>
                <input type="number" v-virtual-keyboard name="modelX" v-model="forgesettings.gpsSettings.x"
                    style="width: 30%;flex-grow: 1;margin-right: 10px;" placeholder="Model 3D Point (X)" />
                <input type="number" v-virtual-keyboard name="modelY" v-model="forgesettings.gpsSettings.y"
                    style="width: 30%;flex-grow: 1;margin-right: 10px;" placeholder="Model 3D Point (Y)" />
            </div>
            <div class="row-input">
                <div style="width: 30%;">Site Angle(Degree)</div>
                <input type="number" v-virtual-keyboard name="angle" v-model="forgesettings.gpsSettings.angle"
                    style="width: 60%;flex-grow: 1;" placeholder="Site Angle (Degree)" />
            </div>
            <div class="modal-row" style="display: flex;width: 100%;justify-content: end;margin: 0px 0 8px -10px;">
                <div class="admin-btn" @click="saveSettings()">Save</div>
            </div>
        </div>
    </div>
</template>

<script>
import { toggleExpandComponent } from '../../../scripts/js/forgeviewer'

export default {
    name: 'AdminSettings',
    props: ['assetid'],
    data() {
        return {
            isExpanded: false,
            gpsSystems: this.$store.state.forgeService.gpsSystems,
        }
    },
    methods: {
        onGPSSystemChanged($event) {
            this.forgesettings.gpsSettings.isIndianSystem = this.gpsSystems.indexOf($event.target.value) == 1;
        },
        saveSettings() {
            if (!parseFloat(this.forgesettings.gpsSettings.angle.toString())) {
                this.$store.dispatch({
                    type: "alert_Forge",
                    message: 'Angle is not filled correctly.'
                })
                return;
            }
            if (!parseFloat(this.forgesettings.gpsSettings.originE.toString())) {
                this.$store.dispatch({
                    type: "alert_Forge",
                    message: 'Origin E is not filled correctly.'
                })
                return;
            }
            if (!parseFloat(this.forgesettings.gpsSettings.originN.toString())) {
                this.$store.dispatch({
                    type: "alert_Forge",
                    message: 'Origin N is not filled correctly.'
                })
                return;
            }
            if (!parseFloat(this.forgesettings.gpsSettings.x.toString())) {
                this.$store.dispatch({
                    type: "alert_Forge",
                    message: 'Point 3D X is not filled correctly.'
                })
                return;
            }
            if (!parseFloat(this.forgesettings.gpsSettings.y.toString())) {
                this.$store.dispatch({
                    type: "alert_Forge",
                    message: 'Point 3D Y is not filled correctly.'
                })
                return;
            }
            this.forgeService.saveSettings(this.assetid, this.forgesettings, () => {
                this.$store.dispatch({
                    type: 'showSuccessfulMessage',
                    message: "Settings saved successfully.", timeout: 2000
                })
            });
        },
        toggleExpanded() {
            toggleExpandComponent(this);
        }

    },
    computed: {
        forgesettings() {
            return this.$store.state.forgeSettings
        },
        selectedgpssystem: {
            get() {
                if (this.forgesettings.gpsSettings.isIndianSystem)
                    return this.forgeService.gpsSystems[1]
                return this.forgeService.gpsSystems[0]
            },
            set(val) {
                this.forgesettings.gpsSettings.isIndianSystem = this.forgeService.gpsSystems[1] == val
            },
        },
        forgeService: {
            get() {
                return this.$store.state.forgeService
            }
        }
    },
}
</script>

<style>.gps-menu {
    flex-grow: 1;
    cursor: pointer;
}</style>
